var search = require('./search');

module.exports = function (apiEndpoint) {
    var pagination = require('./pagination');
    var tagHandler = require('./tag-handler');
    var tableOfContents = require('./table-of-contents');
    const toggleModuleVisibility = require('./toggle-module-visibility');

    search(function (results) {
        var $page = $('#landing-page-with-search');

        var $featureTiles = $page.find("div[class*='__feature-tiles']");
        if ($featureTiles.length) {
            var featureTileBaseClass = $featureTiles.attr('class').split(/\s+/).shift();
            var featureTilesHiddenClass = featureTileBaseClass + '--hidden';

            if ((window.topics && window.topics.length || window.regions && window.regions.length)) {
                if (!$featureTiles.hasClass(featureTilesHiddenClass)) {
                    $featureTiles.addClass(featureTilesHiddenClass);
                }
            }
            else {
                $featureTiles.removeClass(featureTilesHiddenClass);
            }
        }

        var $content;

        if($page.find("div[class*='landing__content']").length) {
          $content = $($page).find("div[class*='landing__content']");
        }
        
        if ($page.find("div[class*='__content-inner']").length) {
          $content = $($page).find("div[class*='__content-inner']");
        }

        if (typeof $content !== 'undefined' && $content.length) {
            var featuredContentClassPattern = "[class*='__featured-content']";
            $featuredContent = $content.find(featuredContentClassPattern);

            if (typeof $featuredContent !== 'undefined' && $featuredContent.length) {
                $content.children().not(featuredContentClassPattern).remove();
                var hiddenFeaturedContentClassName = $featuredContent[0].className.split(" ")[0] + "--hidden";

                if (results.length && /\S/.test(results)) {
                    $content.append(results);

                    if (/data-results-status="default"/.test(results)) {
                        $featuredContent.removeClass(hiddenFeaturedContentClassName);
                    }
                    else {
                        $featuredContent.addClass(hiddenFeaturedContentClassName);
                    }                    
                }                
                else {
                    $featuredContent.removeClass(hiddenFeaturedContentClassName);
                }                
            }
            else {
                $content.empty();
                $content.append(results);
            }            
        }

        pagination(apiEndpoint);
        tableOfContents(apiEndpoint);
        tagHandler(apiEndpoint);
        toggleModuleVisibility();
        
        $('html, body').animate({ scrollTop: 0 });
    }, apiEndpoint);
};